import * as React from 'react';
import { Card } from './Card';
import { AnimatedCollapsibleContent } from './collapsible/AnimatedCollapsibleContent';
import { PageSectionHeader, PageSectionHeaderProps } from './PageSectionHeader';
import { PageSectionVariant } from './PageSectionDefs';
import { assertNever } from '../amorg-common';
import { amorgStyles } from './styles/amorgStyles';
import styled from 'styled-components';

type PageSectionProps = {
    // defaultCollapsed and  - not in its header
    header?:Omit<PageSectionHeaderProps, 'styleVariant'> & {
        title:string
    },
    children:React.ReactNode,
    styleVariant?:PageSectionVariant,
    onCollapsedChanged?:(collapsed:boolean)=>void,
}

export function PageSection(props:PageSectionProps):JSX.Element
{
    const [collapsed, setCollapsed] = React.useState(
        props.header?.defaultCollapsed===undefined ? false : props.header.defaultCollapsed
    );

    React.useEffect(()=>{
        if(props.header?.defaultCollapsed !== undefined && props.header.defaultCollapsed !== collapsed)
            setCollapsed(props.header.defaultCollapsed);

    },[props.header?.defaultCollapsed]);

    function handleCollapseChanged (collapsed:boolean)
    {
        setCollapsed(collapsed);
        if(props.onCollapsedChanged)
            props.onCollapsedChanged(collapsed);
    }

    let content = <div>{props.children}</div>;
    if(props.styleVariant === undefined || props.styleVariant === 'default')
        content = <Card variant={'outlined'}>{props.children}</Card>;
    else if(props.styleVariant === 'default-no-card')
        content = content;
    else if(props.styleVariant === 'dark')
        content = content;
    else if(props.styleVariant === 'dark-card')
        content = <DarkCard>{props.children}</DarkCard>;
    else
    {
        assertNever(props.styleVariant);
    }

    return (
        <section style={{display:'flex', flexDirection:'column', gap:props.styleVariant==='dark-card' ? '0px' : '4px'}}>
            
            {props.header && 
                <PageSectionHeader {...props.header} 
                    onCollapseChanged={handleCollapseChanged} 
                    defaultCollapsed={props.header?.defaultCollapsed}
                    styleVariant={props.styleVariant || 'default'}>
                    {props.header.title}
                </PageSectionHeader>
            }

            <AnimatedCollapsibleContent open={!collapsed}>
                {content}
            </AnimatedCollapsibleContent>
        </section>
    );
}

const DarkCard = styled.div`
    background-color: ${props => amorgStyles(props.theme.colors).card.variants.outlined.default};

    border: ${props => amorgStyles(props.theme.colors).card.variants.outlined.default.border};
    border-top:none;

    border-radius: ${props => amorgStyles(props.theme.colors).card.borderRadius};
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
`;